import Constant from '../../common/constant/Constant';

const {
    IconButton,
    Popover
} = require('@material-ui/core');
const { I18n } = require('aws-amplify');
const { useState } = require('react');
const { duplicateField } = require('./handler/FormListHandler');

export default function MoreActionField({argsAll,field,regionDropId}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            {(field.type != Constant.FORM_TYPE.FIELD_WORKFLOW) && (
                <IconButton
                    className="itemTools"
                    onClick={handleClick}
                >
                    <img src="/assets/image/icon-nav-manage.svg" alt="" />
                </IconButton>
            )}
            <Popover
                className="nav-addManage"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <ul>
                    {/* <li>
                        <span className="item">
                            <img src="/assets/image/edit-icon.svg" alt="" />
                        </span>
                        <span className="text">{I18n.get('USER01BTN007')}</span>
                    </li> */}
                    <li>
                        <span className="item" onClick={(e) => {
                                duplicateField(argsAll, field, regionDropId);
                                setAnchorEl(null);
                                argsAll.setIsChangeData(true);
                            }}>
                            <img src="/assets/image/icon-copy.svg" alt="" />
                        </span>
                        <span className="text">{I18n.get('FIELDFORMBTN013')}</span>
                    </li>
                </ul>
            </Popover>
        </>
    );
}
